import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { StyledLabel } from './FieldLabel.components';
import { HelixPalette, HelixStyles } from '../../../helix';
/**
 * A label for an associated field.
 */
export const FieldLabel = ({ dataId, contextualTooltip, label, labelFor, optional = false, required = false, style }) => {
    return (_jsxs(StyledLabel, Object.assign({ "data-id": dataId, htmlFor: labelFor, sx: style }, { children: [label, contextualTooltip && contextualTooltip, required && (_jsx(Typography, Object.assign({ "data-id": `${dataId}-required`, color: HelixPalette.red50, component: "span" }, { children: "*" }))), optional && (_jsx(Typography, Object.assign({ "data-id": `${dataId}-optional`, style: Object.assign(Object.assign({}, HelixStyles.style_07), { color: HelixPalette.neutral70 }), component: "span", ml: "0.25rem" }, { children: "(Optional)" })))] })));
};
export default FieldLabel;
